import CustomTextBox from "app/components/atoms/customTextBox";
import CustomSelect from "app/components/atoms/customSelect";
import CustomDate from "app/components/atoms/customDate";
import Upload from "app/components/atoms/upload";

export const getProfessionalOrganisationUiSchema = {
  "ui:title": "",
  organisationNameConditional: {
    _ctpt_organisationname_value: {
      "ui:widget": (props) => {
        return <CustomSelect getProps={props} />;
      },
    },
    ctpt_otherorganisationname: {
      "ui:widget": (props) => {
        return <CustomTextBox getProps={props} />;
      },
    },
  },
  _ctpt_organisationcountry_value: {
    "ui:widget": (props) => {
      return <CustomSelect getProps={props} />;
    },
  },
  registrationCategoryConditional: {
    _ctpt_registrationcategory_value: {
      "ui:widget": (props) => {
        return <CustomSelect getProps={props} />;
      },
    },
    ctpt_otherregistrationcategory: {
      "ui:widget": (props) => {
        return <CustomTextBox getProps={props} />;
      },
    },
  },
  ctpt_yearofelection: {
    "ui:widget": (props) => {
      return <CustomTextBox getProps={props} />;
    },
  },
  ctpt_registrationnumber: {
    "ui:widget": (props) => {
      return <CustomTextBox getProps={props} />;
    },
  },
};

export const viewProfessionalOrganisationDetailsUiSchema = {
  "ui:title": "",
  organisationNameConditional: {
    _ctpt_organisationname_value: {
      "ui:widget": (props) => {
        return <CustomSelect getProps={props} />;
      },
    },
    ctpt_otherorganisationname: {
      "ui:widget": (props) => {
        return <CustomTextBox getProps={props} />;
      },
    },
  },
  _ctpt_organisationcountry_value: {
    "ui:widget": (props) => {
      return <CustomSelect getProps={props} />;
    },
  },
  registrationCategoryConditional: {
    _ctpt_registrationcategory_value: {
      "ui:widget": (props) => {
        return <CustomSelect getProps={props} />;
      },
    },
    ctpt_otherregistrationcategory: {
      "ui:widget": (props) => {
        return <CustomTextBox getProps={props} />;
      },
    },
  },
  ctpt_yearofelection: {
    "ui:widget": (props) => {
      return <CustomTextBox getProps={props} />;
    },
  },
  ctpt_registrationnumber: {
    "ui:widget": (props) => {
      return <CustomTextBox getProps={props} />;
    },
  },
};
